import React, { useState, useEffect }  from 'react';

const InputWithSuffix = ({ field, form, suffix, ...props }) => {
    const [ value, setValue ] = useState(field.value)

    useEffect(() => {
        if (!field.value) {
            setValue('');
        }
    }, [field.value, setValue]);

    const formatValue = (value) => {
        return value ? (parseValue(value).trim() + suffix) : ""
    }

    const parseValue = (value) => {
        return value ? value.replace(suffix, "") : value
    }

    const onChange = (e) => {
        setValue(e.target.value)
    }

    const onBlur = async () => {
        setValue(formatValue(value))
        await form.setFieldValue(field.name, formatValue(value))
        form.setFieldTouched(field.name, true)
    }

    const onFocus = () => {
        setValue(parseValue(value))
    }

    return (
        <input {...props} onChange={onChange} onFocus={onFocus} onBlur={onBlur} value={value} />
    )
}

export default InputWithSuffix
